import { useEffect, useState } from "react";
import axios from "../axios";
import DateModal from "./date-modal";
import "./demo-card.css";

export default function DemoCard(props) {
  const { data, from } = props;
  const [isMobile, setIsMobile] = useState(false);
  const [datetime, setDateTime] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showAllExpertise, setShowAllExpertise] = useState(false);

  useEffect(() => {
    // setData(props.data)
    setIsMobile(window.innerWidth <= 768);
  }, [props.data]);

  const getStatusColor = status => {
    switch (status) {
      case "assigned":
        return "#2b93a5";
      case "cancelled":
        return "#9A9A9A";
      case "demo":
        return "#ff9900";
      case "confirmed":
        return "#24983F";
      default:
        return "#1db6c1";
    }
  };
  // Dummy fallback values for missing fields
  const name = data.tutor_name || data.first_name + " " + data.last_name;
  const gender = data.gender;
  const expertise = data.expertise || data.subjects;
  const experience = data.experience;

  // Function to handle expertise display
  const getDisplayedExpertise = () => {
    if (!expertise) return "";

    // Split expertise by comma and trim whitespace
    const expertiseArray = expertise.split(",").map(item => item.trim());

    if (showAllExpertise || expertiseArray.length <= 3) {
      return expertise;
    }

    // Show only first 3 subjects
    return expertiseArray.slice(0, 3).join(", ");
  };

  const expertiseArray = expertise ? expertise.split(",").map(item => item.trim()) : [];
  const hasMoreExpertise = expertiseArray.length > 3;
  const distance = data.distance + " KM";
  const address = data.locality;
  const monthlyFees = data.monthly_fees || data.hourly_rate || data.fee_discuss;
  const status = data.status;
  const profilePic = data.profile_image || data.profile_pic_link || "/Male-icon.svg";
  const isCancelled = status?.toLowerCase() === "cancelled";
  // Right section dummy values
  const statusText = data.status;
  const statusColor = getStatusColor(data.status?.toLowerCase()); // blue or orange for demo scheduled
  const callNumber = data.phone;
  const rightActionText = data.rightActionText ?? "";
  const additionalText = data.additionalText ?? "";

  // Payment handling function
  const handlePaymentClick = async tutorData => {
    setIsLoading(true);
    try {
      const payload = {
        planId: "plan_RNnGWybdWJBpfx",
        userId: JSON.parse(localStorage.getItem("userDetails"))?.userId,
        tutorId: tutorData.id,
      };
      const { data } = await axios.post(`v1/plans`, payload);
      setSubscriptionId(data?.subscriptionId);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Payment error:", error);
      // For demo purposes, simulate success
      alert("Payment initiated successfully!");
    }
  };

  // Razorpay integration
  useEffect(() => {
    if (subscriptionId) {
      const openPopUp = () => {
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          name: "HomeShiksha",
          description: "Tutor Payment",
          image: "./profile.jpg",
          subscription_id: subscriptionId,
          callback_url: `${process.env.REACT_APP_DOMAIN_NAME}v1/subscriptions`,
          prefill: {
            name: "HomeShiksha",
            email: "homeshiksha@gmail.com",
            contact: "9876543210",
          },
          notes: {
            address: "HomeShiksha",
          },
          theme: {
            color: "#212333",
          },
        };

        const razor = new window.Razorpay(options);
        razor.open();
      };
      openPopUp();
    }
  }, [subscriptionId]);

  // Desktop layout
  return (
    <div className="demo-card--container">
      {/* Left colored border */}
      <div className="demo-card--main-content">
        {/* Top row: image, name, gender, badge */}
        <div className="demo-card--top-row">
          <div className="tutor-profilePic--wrapper">
            <img src={profilePic} alt="profile" style={{ objectFit: "cover" }} />
          </div>
          <div className="demo-card--top-info-col">
            <span className="demo-card--tutor-name">{name}</span>
            <img src="/verified-tutor.svg" alt="experience" className="demo-card--info-icon" width={126} height={25} />
            <span className="demo-card--tutor-gender">Gender : {gender}</span>
          </div>
        </div>
        {/* Info rows */}
        <div className="demo-card--info-rows">
          <div className="demo-card--info-row">
            <img src="/expertise.svg" alt="expertise" className="demo-card--info-icon" width={14} height={14} />
            <span className="demo-card--info-label">Expertise:</span>{" "}
            <span className="demo-card--info-value">
              {getDisplayedExpertise()}
              {hasMoreExpertise && !showAllExpertise && (
                <>
                  {", "}
                  <button
                    className="demo-card--see-all-btn"
                    onClick={() => setShowAllExpertise(true)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#2B93A5",
                      cursor: "pointer",
                      fontSize: "inherit",
                      padding: "0",
                      textDecoration: "underline",
                      fontWeight: "500",
                    }}>
                    +{expertiseArray.length - 3} more
                  </button>
                </>
              )}
              {hasMoreExpertise && showAllExpertise && (
                <>
                  {" "}
                  <button
                    className="demo-card--see-less-btn"
                    onClick={() => setShowAllExpertise(false)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#2B93A5",
                      cursor: "pointer",
                      fontSize: "inherit",
                      padding: "0",
                      textDecoration: "underline",
                      fontWeight: "500",
                    }}>
                    Show Less
                  </button>
                </>
              )}
            </span>
          </div>
          <div className="demo-card--info-row">
            <img src="/experience.svg" alt="experience" className="demo-card--info-icon" width={14} height={14} />
            <span className="demo-card--info-label">Experience:</span>{" "}
            <span className="demo-card--info-value">{experience}</span>
          </div>
          <div className="demo-card--info-row">
            <img src="/location.svg" alt="distance" className="demo-card--info-icon" width={14} height={14} />
            <span className="demo-card--info-label">Distance:</span>{" "}
            <span className="demo-card--info-value">{distance}</span>
          </div>
          {/* <div className="demo-card--info-row">
            <img src="/location.svg" alt="address" className="demo-card--info-icon" width={14} height={14} />
            <span className="demo-card--info-label">Address:</span>{" "}
            <span className="demo-card--info-value">{address}</span>
          </div> */}
          <div className="demo-card--info-row">
            <img src="/rupee.svg" alt="fees" className="demo-card--info-icon" width={14} height={14} />
            <span className="demo-card--info-label">Monthly Fees:</span>{" "}
            <span className="demo-card--info-value">{monthlyFees}</span>
          </div>
        </div>
        {/* View Resume */}
        {/* <div className="demo-card--view-resume">View Resume</div> */}
      </div>
      {/* Right content section */}
      <div className="demo-card--right-content">
        <div className="demo-card--right-content-wrapper">
          <div className="demo-card--right-status-row" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span className="demo-card--right-status-text" style={{ color: statusColor }}>
              {statusText?.toUpperCase()}
            </span>
            <div
              className="demo-card--right-status-dot"
              style={{
                background: statusColor,
                width: "8px",
                height: "8px",
                borderRadius: "50%",
              }}></div>
          </div>
          {statusText !== "CANCELLED" && (
            <div
              className="demo-card--right-call-row"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
              }}>
              <div className="demo-card--right-call-icon d-flex align-center justify-center">
                <a
                  href={`tel:${callNumber}`}
                  onClick={e => e.stopPropagation()}
                  aria-label="Call tutor"
                  style={{ display: "inline-flex" }}>
                  <img src="/call-icon-1.svg" alt="call" width={20} height={20} />
                </a>
              </div>
              <div className="demo-card--right-call-label">
                {!isMobile ? "Call Tutor: " : ""}
                {callNumber}
              </div>
            </div>
          )}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {from === "confirmed" && statusText !== "Payment Pending" ? (
            <></>
          ) : (
            <>
              <span className="demo-card--right-action-text">{rightActionText}</span>
              <span className="demo-card--right-action-text-additional">{additionalText}</span>
            </>
          )}
          {statusText === "Payment Pending" ? (
            <div>
              <div className="demo-card--right-payment-btn" onClick={() => handlePaymentClick(data)}>
                {isLoading ? "Processing..." : "Pay Now"}
              </div>
            </div>
          ) : from === "confirmed" && statusText !== "Payment Pending" ? (
            <>
              {" "}
              {selectedDate ? (
                <span className="demo-card--right-action-text">
                  Start Date: {new Date(selectedDate).toLocaleDateString()}
                </span>
              ) : (
                <></>
                // <div
                //   className="demo-card--right-payment-btn"
                //   onClick={() => {
                //     setIsDateModalOpen(true);
                //   }}>
                //   Set Start Date
                // </div>
              )}
              <DateModal
                open={isDateModalOpen}
                onClose={() => setIsDateModalOpen(false)}
                onSubmit={date => {
                  setSelectedDate(date);
                  setIsDateModalOpen(false);
                  // TODO: handle the selected date (e.g., send to backend)
                }}
                initialValue={selectedDate}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
